var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConcretingApproval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9165,
    cy: 18.7938,
    r: 18.5,
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9165 9.54041C13.8105 9.54041 9.6665 13.6844 9.6665 18.7904C9.6665 23.8964 13.8105 28.0404 18.9165 28.0404C24.0225 28.0404 28.1665 23.8964 28.1665 18.7904C28.1665 13.6844 24.0225 9.54041 18.9165 9.54041ZM17.0665 23.4154L12.4415 18.7904L13.7458 17.4862L17.0665 20.7977L24.0873 13.7769L25.3915 15.0904L17.0665 23.4154Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcretingApproval);
export default __webpack_public_path__ + "static/media/concreting-approval.fe4089b8617c3f830d3c84181a48a710.svg";
export { ForwardRef as ReactComponent };